import { AllBadgeVariants as d } from "../types/badge.js";
import { PET_CIRCLE_ASSETS as v } from "../utils/constants.js";
import { formatPrice as g, calculateSavingsPercentage as f } from "../utils/price.js";
const p = (i) => {
  const [e] = i.filter(({ isDefault: r }) => r);
  if (e)
    return e;
  const [a] = i.slice(-1);
  return a;
}, k = (i) => i.filter(({ isAvailable: e }) => e).map(({ badge: e, defaultSku: a, displayName: r, inStock: n, isEligibleForAd: u, price: { autoDeliveryPrice: o, singleOrderPrice: c, wasPrice: t }, sku: s }) => ({
  action: "loading",
  badge: d.includes(e) ? e : void 0,
  displayName: r,
  isAvailable: !0,
  isDefault: a,
  isSoldOut: !n,
  price: {
    autoDelivery: u && o && g(o) || void 0,
    savingsPercentage: t && f(t, c) || void 0,
    singleOrder: c && g(c) || void 0,
    was: t && g(t) || void 0
  },
  quantityInCart: 0,
  sku: s
})), A = (i = []) => i.map(({ badge: e = "", brand: a, brandlessName: r, productId: n, productName: u, productSkus: o = [], review: { averageRating: c = 0, numberOfRatings: t = 0 } }) => {
  const s = k(o), { sku: l } = p(s) ?? {}, m = d.includes(e) ? e : void 0;
  return {
    activeSku: l,
    badge: m,
    brand: a,
    brandlessName: r,
    id: n,
    imageAlt: u,
    imageUrl: `${v.PROD}/images/products/n/${n}.png`,
    link: `/product/${n}`,
    review: {
      average: c,
      count: t
    },
    skus: s
  };
});
export {
  A as mapLegacyProducts
};
